import styles from "./Contents.module.scss"

import React from "react"

import { useChatInfo } from "@shared/contexts"

import classNames from "classnames"

import Chatting from "./Chatting"
import ChattingTerms from "./ChattingTerms"
import Content from "./Content"
import Footer from "./Footer"

function Contents() {
  const { isSearchBarEnabled, chatMenu } = useChatInfo()

  return (
    <div
      className={classNames("contB", {
        [styles.expand]: !isSearchBarEnabled,
      })}
    >
      <Chatting />
      <Content />
      <Footer />
    </div>
  )
}

export default Contents
